import Menu from './components/Menus';
import Swiper from './dependencies/Swiper';
import SimpleLightbox from "simplelightbox";

const menuButton = document.querySelector('.menu-button--primary');
if (menuButton) {
    new Menu();
}

document.querySelectorAll('.swiper').forEach((element) => {
    new Swiper(element, {
        slidesPerView: "auto",
        spaceBetween: 3,
        loop: false,
        pagination: {
            el: element.querySelector('.swiper-pagination'),
            clickable: true,
        },
        navigation: {
            nextEl: element.querySelector('.swiper-button-next'),
            prevEl: element.querySelector('.swiper-button-prev'),
        },
    });
});

document.querySelectorAll('.testimonials').forEach((element) => {
    new Swiper(element, {
        slidesPerView: "auto",
        spaceBetween: 30,
        loop: false,
        pagination: {
            el: element.querySelector('.swiper-pagination'),
            clickable: true,
        },
        navigation: {
            nextEl: element.querySelector('.swiper-button-next'),
            prevEl: element.querySelector('.swiper-button-prev'),
        },
    });
});

document.querySelectorAll('.masonry').forEach((element) => {
    new SimpleLightbox(element.querySelectorAll('a'), {});
});
document.querySelectorAll('.swiper-wrapper').forEach((element) => {
    new SimpleLightbox(element.querySelectorAll('a'), {});
});
document.querySelectorAll('.list').forEach((element) => {
    new SimpleLightbox(element.querySelectorAll('.list__item a'), {});
});


document.querySelectorAll('.bg--bokeh').forEach((element) => {
    let bokehElements = [];

    function createBokeh() {
        const bokehBackground = element;
        const bokeh = document.createElement('div');
        bokeh.className = 'bokeh';

        // Randomize size
        const size = Math.random() * 100 + 20;
        bokeh.style.width = `${size}px`;
        bokeh.style.height = `${size}px`;

        // Randomize initial position within the container
        bokeh.style.left = `${Math.random() * 100}%`;
        bokeh.style.top = `${Math.random() * 100}%`; // Random start position within the viewport height

        // Randomize animation duration and delay
        bokeh.style.animationDuration = `${Math.random() * 5 + 5}s`;
        bokeh.style.animationDelay = `${Math.random() * 2}s`;
        // style blur filter
        bokeh.style.filter = `blur(${Math.random() * 3}px)`;

        bokehBackground.appendChild(bokeh);

        bokehElements.push(bokeh);

        // Remove the bokeh element after animation ends
        bokeh.addEventListener('animationend', () => {
            bokeh.remove();
            bokehElements = bokehElements.filter(item => item !== bokeh);
        });

        // Ensure the number of bokeh elements does not exceed 25
        if (bokehElements.length > 25) {
            const oldestBokeh = bokehElements.shift();
            oldestBokeh.style.animation = 'fade-out 1s forwards';
        }
    }

    // Create an initial batch of bokeh elements
    for (let i = 0; i < 20; i++) {
        createBokeh();
    }

    // Create multiple bokeh elements more frequently
    setInterval(createBokeh, 10000);
});